import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardStatus from './CardStatus';
import { connect } from 'react-redux';
import darkGradient from '../assets/darkGradient.svg'
import mail from '../assets/closeEnvelope.svg';
import LinearProgress from '@material-ui/core/LinearProgress';
import {withRouter} from 'react-router-dom'
import iconModule from '../assets/icon_module_b.png';

import { commonStyles, COLORS } from '../styles/styles';
import {
  getPrograms,
  selectedModule,
  getUserPrograms,
  selectedModuleId
} from '../redux/selectors';

import placeHolder from '../assets/modPlaceHolder.png'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';

import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBProgress
} from "mdbreact";
import { STORAGE_LINK } from '../constants';

// const getCompleted =(mod)=>{
//   var totalCompleted= 0;
   
//     for (let j = 0; j < mod.content.length; j++) {
//       const m = mod.content[j];
      

//           if(m.status=='completed'){
//             totalCompleted++;
//           }
          
     
//   }
//   return totalCompleted
// }
// const getTotal =(mod)=>{
 
//   return mod.content ? mod.content.length : null
// }

const ModulesCard = ({ classes, ...props }) => {
  const {
    isActive: isActiveProp,
    isSelected: isSelectedProp,
    status,
    name,
    description,
    startDate,
    dueDate,
    messages,
    programs,
    moduleId,
    background,
    moduleItem,
    getModule,
    handleBack,
    imageLoadedNow,
    handleImageLoaded
  } = props;
  
  var totalComponents = 0;
  var totalCompleted= 0;
  var percentage = 0
  
  // try {
  //   for (let i = 0; i < programs.length; i++) {
  //     const p = programs[i];
     
  //     for (let j = 0; j < p.modules.length; j++) {
  //       const m = p.modules[j];
  //       
  //       if(m.description===description && m.name===name){
  //         for (let k = 0; k < m.content.length; k++) {
  //           const c = m.content[k];
  //           totalComponents++;
  //           if(c.status=='completed'){
  //             totalCompleted++;
  //           }
            
  //         }
  //       }
        
  //     }
      
  //   }
  // } catch (error) {
    
  // }
  return (
    <div>

    { programs && 
    <MDBCard
    className="card-image rounded-0 z-depth-3"
    style={{
      padding:8,
      margin: '0 0px 5px',
    }}
  >
    <div>
      <div style={{position: 'relative'}}>

        <div class="moduleImg">
          <img src={STORAGE_LINK+background} className="z-depth-0 "
                        alt=""  onLoad={handleImageLoaded}  />
        </div>
        <div style={{position:'absolute', right:10, top:10}}>
          <CardStatus className="dark-grey-text" status={status}/>
        </div>
       
        <div className="moduleCopy" style={{marginTop:'80%'}}>
          {/* <div className="moduleIcon">
            <img src={iconModule} />
          </div> */}
          <h6>
            {name}
          </h6>
          <div className="copy">
            {description}
          </div>
        </div>

        

        
        
        {/* <img src={placeHolder} className="z-depth-0" style={{position:'sticky',top:0,left:0,padding: 0,width: '100%'}} alt=""/>
        <img src={STORAGE_LINK+background} className="z-depth-0"
                        style={{position:'absolute',top:0,left:0,padding: 0, height: '100%', width: '100%'}} alt=""  onLoad={handleImageLoaded}  />
        <div style={{padding: 0, height: '100%', width: '100%', position:'absolute', bottom:0, left:0}} className='background-gradient-main'></div>
          <div className="text-white align-items-center py-5 px-4" style={{position:'absolute', height: '100%', top: 0, width: '100%'}}>
            <div style={{position:'absolute', right:10, top:10}}>
              <CardStatus className="dark-grey-text" status={status}/>
            </div>
            <div style={{width:'90%', position: 'absolute', bottom: 20, left:'0.5rem'}}>
              <h5 tag="h5" className="pt-4">
                <strong>{name}</strong>
              </h5>
              <p>
                {description}
              </p>
              <div className={classes.completionDetails}>
                <span className={classes.progressFig}>{moduleItem.completed+'/'+moduleItem.components}</span> Completed
              </div>
            </div>
          </div> */}
        </div>
    </div>
    <div className="completionDetails">
      <span className={classes.progressFig}>{moduleItem.completed+'/'+moduleItem.components}</span> Completed
    </div>
    <img src={placeHolder} className="z-depth-0 compLoader" alt="" style={{position:'absolute',top:0,left:0,padding: 0,width: '100%'}}/>
    {/* <div className="progressHolder"><MDBProgress className="mb-0" material value={Math.round((moduleItem.completed/moduleItem.components)*100)} color="warning" /></div> */}
    <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
    </MDBCard>
    }
</div>
  );
 
};

const styles = () => ({
  ...commonStyles,
  linearColorPrimary: {
    backgroundColor: '#000000',
  },
  linearBarColorPrimary: {
    backgroundColor: '#8a272a',
  },
  card: {
    color: '#cbcaca',
    width: 200,
    height: 221,
    borderRadius: 0,
    backgroundSize: 'cover',
    marginLeft: 0,
    marginBottom: 0,
    marginRight: 0,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 15,
    paddingBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    border: '0.1px solid #efefef',
    position: 'relative',
    overflow: 'visible',
    backgroundColor: '#fff',
    opacity: 1,
    cursor: 'default',
    justifyContent: 'space-between',
    transition: '.2s height ease',
  },
  cardContent: {
    padding: 0,
  },
  iconsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    margin: 0,
  },
  isActive: {
    opacity: 1,
    cursor: 'pointer',
  },
  moduleDescription: {
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginTop: 10,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  assessmentDescription: {
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    maxHeight: 30,
    overflow: 'hidden',
    color:COLORS.white
  },
  progressFig:{
    fontFamily: 'Gotham-Black',
  }
});
const mapStateToProps = state => ({
  programs: getUserPrograms(state),
  getModule: selectedModuleId(state),
});

export default compose( 
withRouter,
connect(
  mapStateToProps,
),
withState('imageLoadedNow', 'toggleImageLoaded', true),
withHandlers({
  handleBack: props => () => {
    props.history.goBack()
   },
   handleImageLoaded: props => () => {
    props.toggleImageLoaded(false)
  }
}),
withStyles(styles))(ModulesCard);

ModulesCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
  status: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  startDate: PropTypes.string,
  dueDate: PropTypes.string,
  messages: PropTypes.string,
};
